export const initialValues = {
  legal: "",
  itn: "",
  address: "",
  iban: "",
  bank: "",
  bic: "",
  phone: "",
};
